// The server injects the signed Shopify App Proxy path into this meta tag. Shopify's
// usual path is /apps/<handle>, but merchants may configure another allowed prefix.
import { APP_HOME_BASENAME, isEmbeddedAdmin } from './embedded';

const PROXY_PATH = /^(\/apps\/[A-Za-z0-9_-]+)(?=\/)/;

export function proxyBase(): string {
  // The server emits perzo-api-base (and, during the rename, the legacy venza-api-base).
  const meta =
    (document.querySelector<HTMLMetaElement>('meta[name="perzo-api-base"]') ?? document.querySelector<HTMLMetaElement>('meta[name="venza-api-base"]'))?.content?.trim() ?? '';
  if (meta.startsWith('/') && !meta.startsWith('//')) return meta.replace(/\/$/, '');
  const match = PROXY_PATH.exec(window.location.pathname);
  return match?.[1] ?? '';
}

/** React Router basename: set under the proxy prefix, and inside Shopify admin (App Home). */
export function routerBasename(): string | undefined {
  if (isEmbeddedAdmin()) return APP_HOME_BASENAME;
  const base = proxyBase();
  return base && window.location.pathname.startsWith(`${base}/`) ? base : undefined;
}
